function initVideoSection() {
  let videoPlayIcon = document.querySelectorAll('.video-play-button');
  videoPlayIcon.forEach(button => {
    if (button) {
      button.addEventListener('click', () => {
        const externalVideoContainer = button.closest('.video-box').querySelector('.external-video__container');
        const nativeVideoContainer = button.closest('.video-box').querySelector('.native-video__container');
        const externalVideo = button.closest('.video-box').querySelector('.external-video__container iframe');
        const nativeVideo = button.closest('.video-box').querySelector('.native-video__container video');
        const overlayContainer = button.closest('.video-overlay');
        const poster = button.closest('.video-box').querySelector('.video__poster');
        function videoPlay() {
          if (externalVideo) {
            poster.style.display = 'none';
            overlayContainer.style.display = 'none';
            externalVideoContainer.classList.remove('video-container__hide');
          } else if (nativeVideo) {
            poster.style.display = 'none';
            overlayContainer.style.display = 'none';
            nativeVideoContainer.classList.remove('video-container__hide');
            nativeVideo.play();
          }
        }
        function videoEnded() {
          if (externalVideo) {
            externalVideo.onended = function() {
              poster.style.display = 'block';
              overlayContainer.style.display = 'table';
              externalVideoContainer.classList.add('video-container__hide');
            };
          } else if (nativeVideo) {
            nativeVideo.onended = function() {
              poster.style.display = 'block';
              overlayContainer.style.display = 'table';
              nativeVideoContainer.classList.add('video-container__hide');
            };
          }
        }
        videoPlay();
        videoEnded();
      });
    }
  });
}
document.addEventListener('DOMContentLoaded', function () {
  initVideoSection();
});
